import React, { useState } from 'react';
import { Box, Typography, CircularProgress, ImageListItem, ImageList } from '@mui/material';
import { storage } from '../../../firebase/firebaseConfig'; // Importa la configuración de Firebase
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage'; // Funciones de Firebase Storage
import CloudUploadOutlined from '@mui/icons-material/CloudUploadOutlined';
import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';

const FormularioFotosSlidesMisApp = () => {
    const [selectedFiles, setSelectedFiles] = useState([]);  // Estado para almacenar los archivos seleccionados
    const [uploadProgress, setUploadProgress] = useState([]);  // Estado para el progreso de cada carga
    const [uploadedUrls, setUploadedUrls] = useState([]);  // Estado para almacenar las URLs subidas
    const [setLoading] = useState(false);

    // Manejar la selección de archivos
    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);  // Convertir FileList a un array
        setSelectedFiles(files);
        setLoading(true);
        setUploadProgress(new Array(files.length).fill(0));  // Inicializa el progreso en 0 para cada archivo
    };

    // Función para subir los archivos a Firebase Storage
    const handleUpload = () => {
        const promises = [];
        selectedFiles.forEach((file, index) => {
            const storageRef = ref(storage, `fotoslidermisappcalocho/${file.name}`);  // Referencia en Firebase Storage
            const uploadTask = uploadBytesResumable(storageRef, file);

            // Monitorear el progreso de la carga
            uploadTask.on(
                'state_changed',
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    setUploadProgress((prevProgress) => {
                        const newProgress = [...prevProgress];
                        newProgress[index] = progress;
                        return newProgress;
                    });
                },
                (error) => {
                    console.error('Error al cargar la imagen:', error);
                },
                async () => {
                    // Obtener la URL de descarga de la imagen
                    const downloadUrl = await getDownloadURL(uploadTask.snapshot.ref);
                    setUploadedUrls((prevUrls) => [...prevUrls, downloadUrl]);  // Agregar la URL a la lista
                }
            );

            promises.push(uploadTask);
        });

        // Esperar hasta que todas las cargas hayan terminado
        Promise.all(promises)
            .then(() => alert('Todas las imágenes han sido cargadas'))
            .catch((err) => console.error(err));
    };

    return (
        <Box xs={10} md={10} lg={9} sx={{ 
            padding: { xs: 2, sm: 3, md: 4 },  // Ajuste de padding para diferentes pantallas
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignContent: 'center',
            width: '100%',  // Para que se ajuste al 100% del ancho disponible
            maxWidth: { xs: '100%', sm: '90%', md: '80%', lg: '70%' },  // Ancho máximo relativo para diferentes pantallas
            margin: 'auto',  // Centrar horizontalmente
        }}>
            <Typography 
                variant="h4" 
                alignContent={'center'} 
                gutterBottom
                sx={{
                    textAlign: 'center',
                    fontSize: { xs: '1.2rem', sm: '2rem', md: '2.5rem' },  // Cambia el tamaño de fuente en diferentes pantallas
                    marginBottom: { xs: 2, sm: 3 },  // Ajustar el margen en diferentes pantallas
                }}
            >
                Subir fotos para el slider
            </Typography>

            <input
                id="upload-input"
                type="file"
                size='small'
                accept="image/*"
                multiple  // Permite seleccionar múltiples archivos
                onChange={handleFileChange}
                style={{ 
                    marginBottom: 10,
                    textAlign: 'center',
                    alignContent: 'center',
                    width: { xs: '5%', sm: '50%', md: '30%' }, 
                }}
            />
            <LoadingButton
                loadingPosition="start"
                variant="outlined"
                color="#5d0303"
                size='small'
                margin='15px'
                startIcon={<CloudUploadOutlined />}
                onClick={handleUpload}
                sx={{
                    width: { xs: '85%', sm: '50%', md: '40%' },  // Ajustar ancho en diferentes tamaños
                    alignContent: 'center',
                    alignItems: 'center',
                }}
            >
                Subir fotos
            </LoadingButton>

            <Box mt={4} sx={{ 
                display: 'flex',
                flexDirection: 'column',
                alignContent: 'center',
                alignItems: 'center',
            }}>
                {selectedFiles.length > 0 && (
                    <Typography variant="h6" sx={{
                        fontSize: { xs: '0.9rem', sm: '1rem' }, 
                        textAlign: 'center',
                    }}>Progreso de la carga:</Typography>
                )}

                {/* Mostrar progreso de la carga de cada imagen */}
                {selectedFiles.map((file, index) => (
                    <Box key={index} cols={3} gap={8} sx={{ 
                        marginTop: 2,
                        border: '1px solid #5d0303',
                        borderRadius: '4px',
                        width: { xs: '60%', sm: '60%', md: '50%', lg: '40%' },  // Ajustar el ancho en diferentes pantallas
                        display: 'flex',
                        flexDirection: 'column',
                        alignContent: 'center',
                        alignItems: 'center',
                        padding: { xs: 1, sm: 2 },  // Ajustar el relleno en pantallas pequeñas y grandes
                    }}>
                        <Typography variant="subtitle1" sx={{
                            fontSize: { xs: '0.9rem', sm: '1rem' }, 
                            textAlign: 'center'
                        }}>{file.name}</Typography>
                        <CircularProgress
                            variant="determinate"
                            value={uploadProgress[index]}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                marginBottom: 2,
                                width: { xs: '40px', sm: '60px' },  // Ajustar el tamaño en diferentes pantallas
                            }}
                        />
                    </Box>
                ))}

                {/* Mostrar las URLs subidas */}
                {uploadedUrls.length > 0 && (
                <Box mt={4} sx={{ width: '100%' }}>
                    <Typography variant="h6" sx={{ 
                        fontSize: { xs: '0.9rem', sm: '1rem' }, 
                        textAlign: 'center' 
                    }}>
                        Imágenes subidas:
                    </Typography>
                    <ImageList sx={{ width: '70%', height: 'auto' }} cols={2} gap={4}>
                    {uploadedUrls.map((url, index) => (
                        <ImageListItem key={index} sx={{
                            width: { xs: '120px', sm: '150px', md: '200px' },  // Ajustar el tamaño de las imágenes
                            height: 'auto',
                          }}>
                        <img
                            src={url}
                            alt={`Imagen ${index + 1}`}
                            style={{ width: '100%', height: 'auto' }}
                        />
                        </ImageListItem>
                    ))}
                    </ImageList>
                </Box>
                )}
            </Box>
        </Box>
    );
};

export default FormularioFotosSlidesMisApp;